module.exports = __webpack_public_path__ + "static/media/ebilling-picturemark-d.0dcd7024.svg";